import { v4 as uuidv4 } from 'uuid';

const createSessionId = () => {
    const sessionId = uuidv4();
    const sessionExpiry = Date.now() + 60 * 60 * 1000;  
    localStorage.setItem('sessionId', sessionId);
    localStorage.setItem('sessionExpiry', sessionExpiry);

    return { sessionId, sessionExpiry };
};

const verifySession = () => {
    const sessionId = localStorage.getItem('sessionId');
    const sessionExpiry = localStorage.getItem('sessionExpiry');

    if (!sessionId || !sessionExpiry || Date.now() > parseInt(sessionExpiry, 10)) {
        localStorage.removeItem('sessionId');
        localStorage.removeItem('sessionExpiry');
        return false;
    }

    return true;
};

export { createSessionId, verifySession };